import { FC } from "react";
import error from "../../common/images/error-red.svg";

type FieldErrorProps = {
  readonly messageId?: string;
  readonly message: string | undefined;
  readonly className?: string;
};

export const FieldError: FC<FieldErrorProps> = ({
  messageId,
  message,
  className,
}) => {
  return message ? (
    <span className="mkhc-feedback mkhc-feedback-invalid">
      <div className="tw-mt-2">
        <div
          className={["tw-text-danger tw-font-bold tw-text-sm", className].join(
            " "
          )}
          role="alert"
        >
          <img src={error} alt="error" className="tw-h-3.5 tw-inline tw-mr-1" />
          <span id={messageId}>{message}</span>
        </div>
      </div>
    </span>
  ) : (
    <span className="mkhc-feedback mkhc-feedback-hidden" />
  );
};
